import { brandsOf, isComplete } from "../../brandedProducts/select";

// tagging status of a service, shown on the service list and the header
export const STATUS = {
  ready: {
    label: "Ready",
    hint: "Auto-consume ready: every supply has a default brand/variant",
    icon: "check-circle",
    color: "#00a65a",
  },
  brandAvailable: {
    label: "Brand available",
    hint: "A brand can now be selected, or a new brand was added since the last save",
    icon: "bell",
    color: "#2196f3",
  },
  needsBrand: {
    label: "Needs brand",
    hint: "Tagged generics without any brand in this branch yet",
    icon: "exclamation-triangle",
    color: "#f39c12",
  },
  notSet: {
    label: "Not set",
    hint: "No supplies tagged yet",
    icon: "minus-circle",
    color: "#9e9e9e",
  },
};

/**
 * Brands of the tagged generic added after the tag was last saved,
 * other than the chosen one.
 */
export const newBrandsOf = (products, { generic, product }, taggedAt) =>
  taggedAt
    ? brandsOf(products, generic.id).filter(
        ({ _id, createdAt }) =>
          _id !== product?._id &&
          createdAt &&
          new Date(createdAt) > new Date(taggedAt),
      )
    : [];

/**
 * - brandAvailable: a tag without brand now has one, or a new brand was added
 * - needsBrand: a tag still has no brand at all in the branch
 * - ready: every tag has its default brand/variant
 */
export const statusOf = (items = [], products = [], taggedAt) => {
  if (!items.length) return "notSet";

  const hasAvailable = items.some(
    (item) =>
      (!isComplete(item) && brandsOf(products, item.generic.id).length > 0) ||
      newBrandsOf(products, item, taggedAt).length > 0,
  );
  if (hasAvailable) return "brandAvailable";

  return items.every(isComplete) ? "ready" : "needsBrand";
};

const idOf = (value) => value?._id || value || null;

// comparable form of a tag list, used to detect unsaved changes.
// Accepts page items ({ generic, product, variant }) or saved items ({ pgid, product, variant }).
export const signature = (items = []) =>
  JSON.stringify(
    items.map(({ generic, pgid, product, variant, quantity }) => [
      Number(generic?.id || pgid),
      idOf(product),
      idOf(variant),
      Number(quantity),
    ]),
  );
